<template>
    <div>
        <div class="my-4 flex gap-3">
            <button
                v-for="(tab, index) in tabs"
                :key="`tab-button-${index}`"
                type="button"
                :class="`min-w-36 justify-center rounded-xl border-none py-0.5 pl-4 text-base font-bold text-white outline-none ${
                    currentTab === index ? 'pointer-events-none bg-teal-600' : 'bg-teal-800 hover:bg-teal-700'
                }`"
                @click.prevent="setCurrentTab(index)">
                {{ tab.title }}
                <span
                    v-if="tab.badge"
                    class="float-right mx-1 my-0.5 ml-4 h-5 w-5 rounded-full bg-white text-sm text-primary"
                    >{{ tab.badge }}</span
                >
            </button>
        </div>
        <template v-for="(tab, index) in tabs" :key="`tab-${index}`">
            <div v-show="currentTab === index">
                <slot :name="`tab${index + 1}`"></slot>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

export interface Tab {
    title: string
    badge?: string
}

defineProps<{
    tabs: Tab[]
}>()
const currentTab = ref(0)

function setCurrentTab(index: number) {
    currentTab.value = index
}
</script>

<style scoped></style>
